<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel06 from './Jewel06.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel06 ],

    data () {
      return {
        excepts: [ 'えもコレクション' ],
      }
    },

    computed: {
      /**
       * JR10 アイテム群
       * （data の excepts 指定で除外されてしまうので、これを使って再取得）
       * @return {Object[]}
       */
      itemsJR10 () {
        return _.where(Jewel06.data().items, { rare: 'JR', collection: 'えもコレクション' })
      },

      // /**
      //  * プレゼントボックスのアイテムのうち、
      //  * ダイヤモンドコレクション開始時点から取得可能となるもののみ。
      //  * （えもコレクション開始時点から取得可能だったものを除外）
      //  * @return {Object[]}
      //  */
      // itemsPBox () {
      //   const query = { collection: 'プレゼントボックス' }
      //   const excepts = [
      //     'PB-42', 'PB-43', 'PB-44'       , 'PB-44:after1',
      //     'PB-45', 'PB-46', 'PB-47'       , 'PB-47:after1',
      //     'PB-49', 'PB-50', 'PB-50:after1', 'PB-50:after2',
      //     'PB-61',
      //   ]
      //   return _
      //     .where(this.itemsFiltered, query)
      //     .filter(item => !excepts.includes(item.id))
      // },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR10" />
    </template>

    <template #col2>
      <ItemList title="ジュエルコレクション" color="#44cd1f" :items="itemsJewelCollection" />
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col3>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col5>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="ジュエルパクト" color="#c598ff" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#c598ff" :items="itemsDesignPalette" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (プレゼントボックス)
  .Page ::v-deep .Page__col:nth-child(5) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16),
    .Item:nth-child(25),
    .Item:nth-child(26),
    .Item:nth-child(27),
    .Item:nth-child(28) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
